import React, { useContext } from 'react'
// Tools
import { ThemeContext } from 'styled-components'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { useTranslation } from 'react-i18next'

// Components
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import Text from '@navent-jobs/ui-kit/components/text'
import ImgDesktop from '../../../../../assets/images/home/suggestion/no-logueados/bg-desktop.svg'
import ImgMobile from '../../../../../assets/images/home/suggestion/no-logueados/bg-mobile.svg'

import { DataLayer } from '../../../../../constants/gtm-events-home'

// Styles
import {
  ContentWrapper,
  CustomLink,
  Image,
  ImageWrapper,
  Item,
  LinkWrapper,
  List,
  SectionToRigth,
  TextWrapper,
  TitleWrapper,
} from './mixins'

const NotLogedUserSuggest = () => {
  const { t } = useTranslation()
  const { isMobile, isTabletPortrait } = useWindowSize()
  const { colors } = useContext<{ colors }>(ThemeContext)

  const BgImage = isMobile || isTabletPortrait ? ImgMobile : ImgDesktop

  const handleClick = () => {
    DataLayer.handlerCrearCuentaTraking()
  }

  return (
    <ContentWrapper>
      <SectionToRigth>
        <TextWrapper>
          <TitleWrapper>
            <Text type="title" size="sm" fontWeight="semibold" as="h2">
              {t('suggestionsHome.userNotLogged.title')}
            </Text>
          </TitleWrapper>
          <List>
            <Item>
              <Icon name="icon-light-rocket" size="24" color={colors.secondary.normal} />
              <Text size="md" fontWeight="semibold" as="span">
                {t('suggestionsHome.userNotLogged.description1')}
              </Text>
            </Item>
            <Item>
              <Icon name="icon-light-edit-1" size="24" color={colors.secondary.normal} />
              <Text size="md" fontWeight="semibold" as="span">
                {t('suggestionsHome.userNotLogged.description2')}
              </Text>
            </Item>
            <Item>
              <Icon name="icon-light-checkbox-checked" size="24" color={colors.secondary.normal} />
              <Text size="md" fontWeight="semibold" as="span">
                {t('suggestionsHome.userNotLogged.description3')}
              </Text>
            </Item>
            <Item>
              <Icon name="icon-light-save" size="24" color={colors.secondary.normal} />
              <Text size="md" fontWeight="semibold" as="span">
                {t('suggestionsHome.userNotLogged.description4')}
              </Text>
            </Item>
          </List>
          <LinkWrapper>
            <CustomLink
              href="/signin"
              onClick={() => handleClick()}
              linkoptions={{ variant: 'primary', type: 'fill', size: 'medium', target: '_blank' }}
            >
              {t('suggestionsHome.userNotLogged.cta')}
            </CustomLink>
          </LinkWrapper>
        </TextWrapper>
      </SectionToRigth>
      <ImageWrapper>
        <Image bg={BgImage} />
      </ImageWrapper>
    </ContentWrapper>
  )
}

export default NotLogedUserSuggest
